import { API } from "../../utils/_HttpUtils";
import { admin_routes as routes } from "../../constants/api-routes";

const fundBalance = (fund_id) =>
    new API()
        .send("GET", routes.fundBalance(fund_id))
        .then((response) => Promise.resolve(response.data));
export { fundBalance };
